import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../../store/module/user/userSlice"; // Redux slice for user
import apiService from "../../api/auth/auth"; // API service for login
import "./../../css/signup.css";

export default function Login() {
  const [values, setValues] = useState({
    username: "",
    password: "",
  });

  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues((values) => ({
      ...values,
      [name]: value,
    }));
  };

  const [submitted, setSubmitted] = useState(false);
  const [valid, setValid] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch(); // Initialize Redux dispatch

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    // Check if both username and password are provided
    if (values.username && values.password) {
      try {
        // Call the login API service function
        const response = await apiService.loginUser({
          username: values.username,
          password: values.password,
        });

        // If successful, dispatch user data to Redux and navigate to home
        if (response) {
          setValid(true);
          dispatch(setUser({ id: response.id, username: response.username }));
          navigate("/home");
        }
      } catch (error) {
        // Handle errors if login fails
        setError("Invalid username or password. Please try again.");
      }
    } else {
      setError("Please fill out both fields.");
    }
  };

  return (
    <div className="signup-page">
      <div className="form-container">
        <form className="register-form" onSubmit={handleSubmit}>
          <h2>Login</h2>

          {/* Display success message */}
          {submitted && valid && (
            <div className="success-message">
              <h3>Welcome back!</h3>
              <div>Your login was successful!</div>
            </div>
          )}

          {/* Display error message */}
          {error && <div className="error-message">{error}</div>}

          {!valid && (
            <>
              <input
                className="form-field"
                type="text"
                placeholder="Username"
                name="username"
                value={values.username}
                onChange={handleInputChange}
              />
              {submitted && !values.username && (
                <span id="username-error">Please enter your username</span>
              )}

              <input
                className="form-field"
                type="password"
                placeholder="Password"
                name="password"
                value={values.password}
                onChange={handleInputChange}
              />
              {submitted && !values.password && (
                <span id="password-error">Please enter a password</span>
              )}

              <button className="form-field" type="submit">
                Login
              </button>
            </>
          )}

          <div className="already-registered">
            <span>
              Don't have an account? <a href="/signup">Sign up here</a>
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}
